import { getToken, setToken, removeToken } from "@/utils/auth";
import { logout, getInfo } from '@/api/login/login'
import Vue from "vue";

const user = {
  state: {
    user: JSON.parse(sessionStorage.getItem("userInfo")),
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    navs: JSON.parse(sessionStorage.getItem("nav")),
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, user) => {
      state.user = user;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_NAVS: (state, navs) => {
      state.navs = navs;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      let url = `/api/system/login`;
      return new Promise((resolve, reject) => {
        Vue.prototype.topsAjax
          .post(url, userInfo)
          .then((response) => {
            const tokenStr = response.access_token;
            const user = response.userInfo.sysUser;
            const nav = response.nav.filter((p) => p.menuId >= 10000);

            for (let i = 0; i < nav.length; i++) {
              if (nav[i].component && !nav[i].component.startsWith("/") && nav[i].isFrame === "1") {
                nav[i].component = "/" + nav[i].component;
              }
              for (let j = 0; j < nav[i].children.length; j++) {
                if (!nav[i].children[j].component.startsWith("/") && nav[i].isFrame === "1") {
                  nav[i].children[j].component = "/" + nav[i].children[j].component;
                }
              }
            }

            const userInfo = response.userInfo.sysUser;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            commit("SET_USERINFO", user);
            commit("SET_NAVS", nav);
            sessionStorage.setItem("nav", JSON.stringify(nav));
            sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          // 找到 menuId 为 8 的菜单项
          const parentMenu = res.nav.find((p) => p.menuId === 8);
          
          // 如果找到了 menuId 为 8 的菜单，使用其子菜单作为一级菜单
          const nav = parentMenu && parentMenu.children ? parentMenu.children : [];

          for (let i = 0; i < nav.length; i++) {
            if (nav[i].component && !nav[i].component.startsWith("/") && nav[i].isFrame === "1") {
              nav[i].component = "/" + nav[i].component;
            }
            // 处理子菜单的子菜单（如果存在）
            if (nav[i].children && nav[i].children.length > 0) {
              for (let j = 0; j < nav[i].children.length; j++) {
                if (!nav[i].children[j].component.startsWith("/") && nav[i].children[j].isFrame === "1") {
                  nav[i].children[j].component = "/" + nav[i].children[j].component;
                }
              }
            }
          }

          const user = res.user
          console.log(user)
          commit("SET_USERINFO", user);
          commit("SET_NAVS", nav);
          sessionStorage.setItem("nav", JSON.stringify(nav));
          sessionStorage.setItem("userInfo", JSON.stringify(user));
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },
  },
};

export default user;
